var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-multi-select", {
    attrs: {
      label: _vm.label,
      fancy: _vm.fancy,
      value: _vm.value,
      items: _vm.bankKinds,
    },
    on: {
      input: function ($event) {
        return _vm.onInput($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }